import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Logs, Activities, Updates, Users } from 'api/collections';
import { ModalController, AlertController, NavParams, NavController, Content } from 'ionic-angular';
import * as moment from 'moment';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';

import { LogType, LogCategories, Project, Log, Update, Activity } from 'api/models';

import { FilterMenuModal } from '../../directives/filter_menu/filter_menu.component.ts';
import { LogView } from '../log-view/log-view';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { ISDEV } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

type SortField = 'createdDate' | 'modifiedDate' | 'logTitle';
type LogFilter = {
  type: 'logType',
  selectedValues: Array<LogType>,
} | {
  type: 'updatePeriod',
  selectedValues: Array<any>,
} | {
  type: 'logCategory',
  selectedValues: Array<LogCategories>,
};

const DEFAULT_FILTER_SECTIONS = [
  {
    id: 'logType',
    label: 'Log Types',
    multiselect: false,
    options: [
      { value: LogType.GENERAL, label: 'Daily' },
      { value: LogType.ACTIVITY, label: 'Activity' },
    ],
  },
  {
    id: 'logCategory',
    label: 'Log Category',
    multiselect: true,
    options: [
      { value: LogCategories.CHANGES, label: 'Changes' },
    { value: LogCategories.DELAYS, label: 'Delays/Issues' },
    { value: LogCategories.INSPECTIONS, label: 'Inspections' },
    { value: LogCategories.SAFETY, label: 'Site Safety' },
    { value: LogCategories.NOTES, label: 'Subcontractor Notes' },
    { value: LogCategories.TODO, label: 'To Do List' },
    { value: LogCategories.WEATHER, label: 'Weather' },
    ],
  },
];

@Component({
  templateUrl: 'logs.html'
})
export class LogsPage implements OnInit {
  @ViewChild(Content) content: Content;
  logs: Array<Log & { updateId?: string, update?: Update }>;
  selectedProject: Project | void;
  projectId?: string;
  isPM?: string;
  public isDev = ISDEV;

  // LogListBarHeader
  sortField: SortField;
  sortAsc: boolean;
  filterText: string;
  wipFilterText: string;
  isShowingTextFilter: boolean;

  filterMenuModal: any;
  filterSections: Array<any /*FilterSections*/>;
  wipFilterSections: Array<any /*FilterSections*/>;
  sortOptions: Array<{value: string, label: string}>;
  activities: Activity[];
  // End LogListBarHeader

  constructor(
    public navParams: NavParams,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    public httpService: HttpService,
    public projectService: ProjectService,
    private sharedService: SharedService,
    public authenticationService: AuthenticationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.sortAsc = false;
    this.sortField = 'createdDate';
    this.filterText = ''; // undefined;
    this.wipFilterText = '';
    this.isShowingTextFilter = false;
    this.filterSections = DEFAULT_FILTER_SECTIONS;
    this.sortOptions = [{
      value: 'createdDate',
      label: 'Created Date',
    }, {
      value: 'modifiedDate',
      label: 'Modified Date',
    }, {
      value: 'logTitle',
      label: 'Log Title',
    }];
  }

  ngOnInit() {
  if(this.isDev == true) { console.log('logs page') }
  const projectIdReactive = this.navParams.get('projectIdReactive');
  this.projectId =  projectIdReactive && projectIdReactive.get();
  this.selectedProject = this.projectService.getProject(this.projectId);
  this.activities = Activities.find({}).fetch();
  // MeteorObservable.subscribe('logs', this.projectId).subscribe();
  this.httpService.MeteorSubscribe('logs', this.projectId)
  .then(()=>this.httpService.privateLoopAction(true))
  .then(()=>{
    this.populateLogs();
  })
    MeteorObservable.autorun().subscribe(async () => {
      const projectIdReactive = this.navParams.get('projectIdReactive');
      this.projectId =  projectIdReactive && projectIdReactive.get();
      this.selectedProject = this.projectService.getProject(this.projectId);
      this.activities = Activities.find({}).fetch();

      // MeteorObservable.subscribe('logs', this.projectId).subscribe();
      this.httpService.MeteorSubscribe('logs', this.projectId);
      this.populateLogs();
    });
  }



  async populateLogs() {
    this.logs = await this.findLogs();
  }

  async findLogs(): Promise<Array<Log & { updateId?: string, update?: Update }>> {
    if (!this.projectId) {
      return [];
    }

    let logs = Logs.find({
      projectId: this.projectId,
      archived: { $ne: true },
    }).fetch();

    for(const i in logs){
      logs[i].featuredImage=logs[i].featuredImage?await this.authenticationService.imageConverter(logs[i].featuredImage):logs[i].featuredImage
    }


    const augmentedLogs: Array<Log & {updateId?: string, update?: Update }> = logs.map(log => {
      // This will make the last message reactive


      let update = undefined;
      let updateId = undefined;
      const p6ActivityId = log && log.p6ActivityId;
      if (p6ActivityId) {
        const activity = Activities.find({
          p6ActivityId: log.p6ActivityId,
          projectId: log.projectId,
        }, {
          limit: 1,
          sort: { createdAt: -1 },
        }).fetch()[0];
        updateId = (activity || {updateId: undefined}).updateId;
        if (updateId) {
          update = Updates.findOne(updateId);
        }
      }

      return {
        ...log,
        update,
        updateId,
      };
    });
    console.log("this.selectedProject['pmIds']", this.selectedProject, this.selectedProject['pmIds'], (this.selectedProject['pmIds'] || []))

    this.isPM = (this.selectedProject['pmIds'] || []).includes(this.authenticationService.MeteorUserId())
    const usersToFind = _.uniq((this.selectedProject['memberIds'] || []).concat(this.selectedProject['pmIds'])) || [];
    const creatorSection = this.filterSections.find(fs=>fs.id==='creator');
    let userIdsAreAlreadyCorrect = creatorSection && creatorSection.options && usersToFind.length === creatorSection.options.length;
    creatorSection && creatorSection.options && creatorSection.options.forEach(option => {
      console.log("OPION", usersToFind)
      if(usersToFind && !(usersToFind||[]).includes(option.value)) {
        userIdsAreAlreadyCorrect = false;
      }
    });

    if(this.isPM && (!creatorSection || !userIdsAreAlreadyCorrect)) {

      const users = Users.find({_id: {$in: usersToFind}}).fetch();
      this.filterSections = [{
          id: 'creator',
          label: 'Creator',
          multiselect: true,
          options: users.map(user=>{
            return {value: user._id, label: (user.profile && user.profile.name) || "Un-named User"}
          }).sort(function(a, b){
            if(a.label < b.label) { return -1; }
            if(a.label > b.label) { return 1; }
            return 0;
          })
      } as any].concat(DEFAULT_FILTER_SECTIONS)
    }

    const filters = this.getFiltersFromFilterSections();
    const filteredLogs = augmentedLogs.filter(log => {
      return this.doesLogPassFilter(log, filters);
    });
    const ascOrDesc = this.sortField === "logTitle" ? !this.sortAsc : this.sortAsc;
    const sortedLogs = (ascOrDesc ? _.identity : _.reverse)(_.sortBy(filteredLogs, log => {
      switch (this.sortField) {
        // is earlyStart and earlyFinish the same as projectedStart / projectedFinish?
        case 'createdDate':
          return moment(log.createdAt).unix();
        case 'modifiedDate':
          const lastModified = log.lastModified || log.createdAt; // (log.lastLogMessage && log.lastLogMessage.createdAt) || log.createdAt;
          return moment(lastModified).unix();
        case 'logTitle':
          return log.title;
        default:
          return;
      }
    }));

    return sortedLogs;
  }



  doesLogPassFilter(log: Log & { updateId?: string }, filters: Array<LogFilter>): boolean {
    let passesPMTest = true;
    if(!this.isPM && log.p6ActivityId){
      passesPMTest = !!Activities.findOne({"p6ActivityId": log.p6ActivityId, assignedUserId: this.authenticationService.MeteorUserId()})
    }
    // if there's a text Filter (or we're in text filter mode), we ignore the (regular) filters
    let passesTextSearch = true;
    if (this.filterText) {
      const regex = new RegExp(this.filterText, 'i');
      // this isnt strictly correct (@see turkish "i" problem), but will work for just about any practical case
      const containsLogTitle = log.title.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0;
      passesTextSearch = containsLogTitle;
    }


    const filterMap = _.keyBy(filters, filter => filter.type);
    const passesFilters = _.every(_.keys(filterMap), filterKey => {
      const filterObj = filterMap[filterKey];
      if (filterObj.type === 'logType') {
        return _.some(filterObj.selectedValues, selectedValue => {
          return selectedValue === log.logType;
        });
      } else if (filterObj.type === 'updatePeriod') {
        return _.some(filterObj.selectedValues, selectedValue => {
          return selectedValue === log.updateId;
        });
      } else if (filterObj.type === 'logCategory') {
        return _.some(filterObj.selectedValues, selectedValue => {
          return selectedValue === log.category;
        });
      } else if (filterObj['type'] === 'creator') {
        return _.some(filterObj['selectedValues'], selectedValue => {
          return selectedValue === log.creatorId;
        });
      } else {
        console.warn('Ignoring unknown activityListHeader filter: ', filterKey, filterObj);
      }
      return true;
    });

    return passesFilters && passesTextSearch && passesPMTest;
  }

  /** BEGIN LogListHeaderBar **/

  onChangeSortField(newSortField: SortField): void {
    this.sortField = newSortField;
    this.populateLogs();
  }

  toggleSortOrder(): void {
    this.sortAsc = !this.sortAsc;
    this.populateLogs();
  }

  runTextFilter(): void {
    this.filterText = this.wipFilterText;
    this.closeTextFilter();
    this.populateLogs();
  }

  showTextFilter(): void {
    this.isShowingTextFilter = true
    this.populateLogs();
  }

  clearSearch() {
    this.wipFilterText = '';
    this.filterText = '';
    this.content.resize();
    this.populateLogs();
  }

  closeTextFilter(event?: Event): boolean {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isShowingTextFilter = false;
    this.content.resize();

    return false;
  }

  getFiltersFromFilterSections(): Array<LogFilter> {
    return this.filterSections.map(filterSection => {
      const selectedValues = filterSection.options.filter(option => option.selected).map(option => option.value);
      return {
        type: filterSection.id,
        selectedValues,
      };
    }).filter(filter => filter.selectedValues.length > 0);
  }

 getLabelForSortValue(value, label:string): string {
    return (((this.sortOptions || []).find(sortOption=>sortOption.value===value) || {value} || {label}).label)
  }

  openFilterMenu(): void {
    this.wipFilterSections = _.cloneDeep(this.filterSections);
    this.filterMenuModal = this.modalCtrl.create(FilterMenuModal, {
      sections: this.wipFilterSections,
      onDone: () => this.didChangeFilters(),
      onCancel: () => this.didCancelFilters(),
      title: 'Filter Logs'
    });
    this.filterMenuModal.present();
  }

  didChangeFilters(): void {
    this.filterSections = this.wipFilterSections;
    this.populateLogs();
    this.filterMenuModal && this.filterMenuModal.dismiss();
    this.content.resize();
  }

  didCancelFilters() {
    this.filterMenuModal && this.filterMenuModal.dismiss();
  }

  clearFilters() {
    this.content.resize();
    if(this.isPM){
      const users = Users.find({}).fetch();
      this.filterSections = [{
          id: 'creator',
          label: 'Creator',
          multiselect: true,
          options: users.map(user=>{
            return {value: user._id, label: (user.profile && user.profile.name) || "Un-named User"}
          })
      } as any].concat(DEFAULT_FILTER_SECTIONS)
    } else {
      this.filterSections = DEFAULT_FILTER_SECTIONS;
    }
    this.populateLogs();
  }

  /** END LogListHeaderBar **/

  goToLog(log): void {
    const modal = this.modalCtrl.create(LogView, {logId: log._id}, {enableBackdropDismiss: false});
    modal.present();
  }

  removeLog(log: Log): void {

    const alert = this.alertCtrl.create({
      buttons: [
        {
          text: 'Yes',
          role: 'cancel',
          handler: () => {

            this.httpService.MeteorCall('removeLog', log._id)
            .then(() => {
              Logs.remove({_id:log._id});
              console.log('Log deleted');
            })
            .catch((e: Error) => {
              this.handleError(e);
            });
          }
        }, 
        'No'
      ],
      message: 'Are you sure you want to delete this log?',
      title: 'Are you sure?'
    });

    alert.present();

    alert.onDidDismiss(() => {
      this.populateLogs();
      this.content.resize();
      this.cdr.detectChanges();
      });
  }

  handleError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/logs/logs.ts